import Loading from '../components/Loading';
import Lesson from '../components/Lesson';
import { useGlobalContext } from '../context/GlobalContext';
import { useEffect } from 'react';
import styled from 'styled-components';

const Lessons = ({ amount }) => {
  const { lessons_loading, lessons_error, lessons, getLessons } =
    useGlobalContext();

  useEffect(() => {
    getLessons();
  }, []);

  if (lessons_loading) {
    return <Loading />;
  }

  if (lessons_error) {
    return (
      <h2 className='lessons-error'>
        There was an error fetching the data from the server...
      </h2>
    );
  }

  const lessonsReduced = amount ? lessons.slice(0, amount) : lessons;
  const shownLessons = lessonsReduced.filter((lesson) => {
    if (lesson.showLesson) {
      return lesson;
    }
    return null;
  });

  return (
    <LessonsContainer>
      <div className='lessons'>
        <h1>Geplande lessen</h1>
        <div>
          <section>
            {shownLessons.map((lesson) => {
              return <Lesson {...lesson} key={lesson._id} />;
            })}
          </section>
        </div>
      </div>
    </LessonsContainer>
  );
};

const LessonsContainer = styled.div`
  h1,
  h2 {
    color: var(--primaryBtnColor);
  }
`;

export default Lessons;
